<svg class="ct__ring" viewBox="0 0 36 36" aria-hidden="true">
  <circle class="ct__track" cx="18" cy="18" [attr.r]="radius" />
  <circle
    class="ct__progress"
    cx="18"
    cy="18"
    [attr.r]="radius"
    [attr.stroke-dasharray]="circumference"
    [attr.stroke-dashoffset]="dashOffset()"
  />
</svg>
<span class="ct__seconds" aria-hidden="true">{{ secondsLeft() }}</span>
